'use client';
import React from 'react';
import { Box, Stack } from '@mui/material';
import { MarketingPageComponentProps } from '@services/launches/fetchLaunchMarketingContent';
import ParallaxText from '@components/ParallaxText';
import ReactHtmlParser from '@libs/reactHtmlParser';
import SplideSlider from '@components/SplideSlider';
import { ArrowLeftIcon, ArrowRightIcon } from '@components/SVGIcon/Icons';
import CustomImage from '@components/CustomImage';
import cn from './style.module.scss';
export default function WharfCanvas(props: MarketingPageComponentProps) {
  const wharfCanvasStorySettings = {
    type: 'slide',
    rewind: false,
    speed: 2000,
    pagination: true,
    arrows: true,
    autoplay: true,
    interval: 6000,
  };
  const wharfCanvasStorySliderElement =
    props?.locale?.section?.ransomCanvasSlider ?? [];

  return (
    <Stack
      component="section"
      className={cn.wharfCanvasWrapper}
      id="wharfStoriesID"
    >
      <Box className={cn.wharfCanvasInner}>
        <Box className={cn.wharfCanvasBlock}>
          <SplideSlider
            showArrows
            showPagination
            arrowsClassName={cn.wharfCanvasArrows}
            prevClassName={cn.canvasArrowsPrev}
            nextClassName={cn.canvasArrowsNext}
            paginationClassName={cn.wharfCanvasPagination}
            dotClassName={cn.canvasPaginationDots}
            activeDotClassName={cn.canvasPaginationActive}
            prevArrow={<ArrowLeftIcon />}
            nextArrow={<ArrowRightIcon />}
            options={wharfCanvasStorySettings}
          >
            {wharfCanvasStorySliderElement.map((item: any, index: number) => (
              <Box key={item.url ?? index} className={cn.wharfCanvasStory}>
                <CustomImage
                  src={item.url}
                  alt={item.alt ?? `slider-image-${index}`}
                  width={1200}
                  height={800}
                />
              </Box>
            ))}
          </SplideSlider>
        </Box>
        <Box className={cn.wharfCanvasContent}>
          <Box className={cn.wharfContentInner}>
            <Box className={cn.wharfContentElement}>
              <Box className={cn.wharfContentElement__heading}>
                <ParallaxText
                  variant="h2"
                  animationType="zoomIn"
                  animationDuration={500}
                >
                  {ReactHtmlParser(props.locale.section['ransomCanvasHeading'])}
                </ParallaxText>
              </Box>
              <Box className={cn.wharfContentElement__data}>
                <ParallaxText
                  variant="p"
                  animationType="zoomIn"
                  animationDuration={500}
                >
                  {ReactHtmlParser(props.locale.section['ransomCanvasContent'])}
                </ParallaxText>
              </Box>
            </Box>
          </Box>
        </Box>
      </Box>
    </Stack>
  );
}
